export const token = document.querySelector('meta[name="csrf-token"]').content

const wrapped = {
  'X-CSRF-Token': token,
}

export default wrapped



// WEBPACK FOOTER //
// ./app/javascript/utils/csrf.js